import { commonListingInitial } from '../../store/InitialStore';
import * as types from '../../actions/ActionTypes';

export default function CustomersReducer(state = commonListingInitial, action) {
  const { type, payload,totalCount } = action;

  switch (type) {
    case types.CUSTOMER_LISTING_LOADING:
      return {loading : true  , list : [],totalCount:0};
    case types.CUSTOMER_LISTING_SUCCESS:
      return {loading : false  , list : payload,totalCount};    
    default:
      return state;
  }
}
